import {actions as errorActions} from './error.state';
import {actions} from './session.state';
import {push} from 'react-router-redux';

/**
 * Standardised error handling, allowing as much feedback to be shown to the user as possible.
 *
 * TODO We also need to report errors to back-end so it can be used to help debug issues.
 *
 * @param dispatch
 * @param ignore403 If true, dont check 403 for auth redirection
 * @returns {function(*=)}
 */
const handleError = (dispatch, ignore403 = false, forceLogout = false) => e => {
	if (forceLogout || (!ignore403 && e.status && e.status === 403)) {
		// Notify user they're logged out and give them option to log back in
		dispatch(actions.sessionClear());
		localStorage.clear();
		dispatch(push('/loggedout'));
	} else {
		console.error(e);
		
		let title;
		
		if (e.status && e.status === 400) {
			title = 'Bad request';
		} else if (e.status && e.status === 401) {
			title = 'Unauthorized';
		} else if (e.status && e.status === 403) {
			title = 'Permission denied';
		} else if (e.status && e.status === 404) {
			title = 'Could not find resource';
		} else if (e.status && e.stats >= 500) {
			title = 'Unexpected server error';
		} else {
			title = 'Unexpected request error'
		}
		
		dispatch(errorActions.errorSet({
			title,
			message: e && e.message ? e.message : 'An unexpected error occurred without a nice error message for us to show, please report this to the development team.'
		}));
	}
};

export default handleError;


// WEBPACK FOOTER //
// ./src/handleError.js